import { TaxGroupDetailModel } from "./tax-group-details";

export class TaxGroup {

    constructor() {
        this.TaxGroupDetail = Array<TaxGroupDetailModel>();
        this.TaxGroupCode = "";
        this.TaxLevel = 1;
        this.isProduct = true;
    }

    RowIndex: number;
    TaxGroupCode: string;
    TaxGroupName: string;
    MultiNames: string;
    IsAutoNumbering: boolean;
    IsInserting: boolean;
    TaxLevel: number; // 1 for product, 2 for Bill(Invoice)
    isProduct: boolean;
    TaxGroupDetail: TaxGroupDetailModel[];
}